import { createSelector, createSlice } from '@reduxjs/toolkit';
import { LOGIN_SOURCES } from '../../../types/paramsConfig.js';
export const initialSourceDataState = {
    loginSource: LOGIN_SOURCES.OTHER,
    redirectionUrl: null,
    disableCvUpload: false,
    forceRedirect: false,
    callbackFunction: null,
    disableModalSlideIn: false,
    isDismissible: true,
    showRecruiterContinueButton: false,
    skipReturningUser: false,
};
export const sourceDataSlice = createSlice({
    name: 'sourceData',
    initialState: initialSourceDataState,
    reducers: {
        initSourceData: (state, actions) => {
            state.loginSource = actions.payload.loginSource;
            state.redirectionUrl = actions.payload.redirectionUrl;
        },
        updateLoginSource: (state, actions) => {
            state.loginSource = actions.payload;
        },
        updateRedirectAfterSuccessfulRegistration: (state, actions) => {
            state.disableCvUpload = actions.payload;
        },
        updateForceRedirect: (state, actions) => {
            state.forceRedirect = actions.payload;
        },
        updateRedirectionUrl: (state, actions) => {
            const isEncoded = actions.payload?.includes('%');
            state.redirectionUrl = isEncoded
                ? decodeURIComponent(actions.payload)
                : actions.payload;
        },
        updateCallbackFunction: (state, actions) => {
            state.callbackFunction = actions.payload;
        },
        updateDisableModalSlideIn: (state, actions) => {
            state.disableModalSlideIn = actions.payload;
        },
        updateIsDismissible: (state, actions) => {
            state.isDismissible = actions.payload;
        },
        updateShowRecruiterContinueButton: (state, actions) => {
            state.showRecruiterContinueButton = actions.payload;
        },
        updateSkipReturnUser: (state, actions) => {
            state.skipReturningUser = actions.payload;
        },
    },
});
export const { initSourceData, updateLoginSource, updateRedirectionUrl, updateCallbackFunction, updateDisableModalSlideIn, updateRedirectAfterSuccessfulRegistration, updateIsDismissible, updateShowRecruiterContinueButton, updateSkipReturnUser, } = sourceDataSlice.actions;
const sourceDataState = (state) => state.core.sourceData;
export const sourceDataActions = sourceDataSlice.actions;
export const loginSourceSelector = createSelector(sourceDataState, ({ loginSource }) => loginSource);
export const disableCvUploadSelector = createSelector(sourceDataState, ({ disableCvUpload }) => disableCvUpload);
export const redirectionUrlSelector = createSelector(sourceDataState, ({ redirectionUrl }) => redirectionUrl);
export const callbackFunctionSelector = createSelector(sourceDataState, ({ callbackFunction }) => callbackFunction);
export const isDismissibleSelector = createSelector(sourceDataState, ({ isDismissible }) => isDismissible);
export const disableModalSlideInSelector = createSelector(sourceDataState, ({ disableModalSlideIn }) => disableModalSlideIn);
export const showRecruiterContinueButtonSelector = createSelector(sourceDataState, ({ showRecruiterContinueButton }) => showRecruiterContinueButton);
export const skipReturningUserSelector = createSelector(sourceDataState, ({ skipReturningUser }) => skipReturningUser);
export default sourceDataSlice.reducer;
//# sourceMappingURL=sourceDataSlice.js.map